import React from 'react';

export interface Props {}

export const BackroomSection: React.FC<Props> = props => {
  return <div>Backroom</div>;
};
BackroomSection.displayName = 'BackroomSection';

export default BackroomSection;
